import * as z from 'zod/mini'
import { endAfterStart, isoDateTime } from '../../schemas/common'
import { reservationBlueprintFields } from '../../schemas/reservation-blueprint'

const blueprintBodyFields = {
  ...reservationBlueprintFields,
  description: z.optional(reservationBlueprintFields.description),
  durationAfter: z.optional(reservationBlueprintFields.durationAfter.check(z.positive())),
  /** The booking widget offers a note for the premise. Omitted means off. */
  allowCustomerNote: z.optional(reservationBlueprintFields.allowCustomerNote),
  /** When the blueprint starts taking bookings; now when left out. It may not start in the past. */
  start: z.optional(isoDateTime),
  end: isoDateTime,
  /** Ids are resolved within the premise in `ReservationBlueprintService` (404). Duplicates are ignored. */
  activityId: z.uuid(),
  placeIds: z.optional(z.array(z.uuid())),
  employeeIds: z.optional(z.array(z.uuid())),
}

export const createReservationBlueprintBody = z
  .object(blueprintBodyFields)
  .check(z.superRefine(endAfterStart('start', 'end')))
export type CreateReservationBlueprintBody = z.infer<typeof createReservationBlueprintBody>

/**
 * A partial edit - what is left out keeps its stored value. `ReservationBlueprintService` checks the
 * merged dates; the schema checks the pair only when both are sent.
 */
export const editReservationBlueprintBody = z
  .partial(z.object(blueprintBodyFields))
  .check(z.superRefine(endAfterStart('start', 'end')))
export type EditReservationBlueprintBody = z.infer<typeof editReservationBlueprintBody>

export const setReservationBlueprintActiveBody = z.object({ active: z.boolean() })
export type SetReservationBlueprintActiveBody = z.infer<typeof setReservationBlueprintActiveBody>

/** A reservation blueprint URL, looked up by `ReservationBlueprintGuard` within the premise. */
export const reservationBlueprintParams = z.object({ reservationBlueprintId: z.uuid() })
export type ReservationBlueprintParams = z.infer<typeof reservationBlueprintParams>
